module.exports = __webpack_public_path__ + "img/img_avatar.61d90d84.png";